import React, { useRef, useState, useEffect } from 'react'
import styles from './Heatmap.scss'
import { MapV2 } from 'common/MapV2'
import { Icon } from 'common/Icon'
import { NoScrollLayout } from 'common/layouts/NoScrollLayout'
import { Topo } from 'common/styleguide/Topo'
import { tileServices } from 'lib/tileServices'
import { useFormatMessage, featureNames } from 'lib/localization'
import { defineMessages } from 'react-intl'
import { getCurrentUser } from 'lib/utils'
import cx from 'classnames'

const messages = defineMessages({
  toKnow: {
    id: 'heatmap.toKnowV2',
    defaultMessage: 'Explore, plan, and navigate the best routes - starting from home or halfway across the globe.'
  },
  toKnow1: {
    id: 'heatmap.toKnow1V2',
    defaultMessage: "The heatmap displays 'heat' generated by cyclists worldwide using the two most recent years of publicly-logged trip data."
  },
  toKnow2: {
    id: 'heatmap.toKnow2V2',
    defaultMessage: 'The heatmap is updated weekly so that it is continually growing and accurate.'
  },
  toKnow3: {
    id: 'heatmap.toKnow3V2',
    defaultMessage: 'Users may opt out at any time through their <a>privacy settings</a>.'
  },
  toKnow4: {
    id: 'heatmap.toKnow4V2',
    defaultMessage: 'The heatmap is available as an overlay in the mobile and web route planners for <a>Premium members</a>.'
  },
  learnMore: {
    id: 'heatmap.learnMoreV2',
    defaultMessage: 'Learn more about the heatmap'
  }
})

export const Heatmap = () => {
  const mapRef = useRef(null)
  const panelRef = useRef(null)
  const [overlay, setOverlay] = useState(tileServices['rwgps'])
  const [expanded, setExpanded] = useState(true)

  useEffect(() => {
    mapRef.current?._mapEngine?.initialized() && mapRef.current._mapEngine.resizeToParentHeight()
  }, [expanded])

  const { lat, lng } = getCurrentUser()
  const viewportProp = lat && lng ? { initialViewport: { center: { lat, lng }, zoom: 13 } } : {}

  return (
    <NoScrollLayout>
      <div className={styles.layout}>
        <div className={cx(styles.mapPanel, expanded && styles.expanded)}>
          <Topo ref={panelRef} style={{ height: '100%', width: '100%' }}>
            <MapV2
              showHeatLayer
              rwgpsOverlaysOnly
              {...viewportProp}
              ref={mapRef}
              overlay={overlay}
              container={panelRef}
              onChangeOverlay={setOverlay}
            />
          </Topo>
        </div>
        <div className={cx(styles.toggle, expanded && styles.expanded)} onClick={() => setExpanded(!expanded)}>
          <Icon i={`md-arrow-drop${expanded ? 'right' : 'left'}`} />
        </div>
        {expanded && <SidePanel />}
      </div>
    </NoScrollLayout>
  )
}

const SidePanel = () => {
  const fm = useFormatMessage()
  return (
    <div className={styles.sidePanel}>
      <div><strong>Ride with GPS {fm(featureNames.heatmap)}</strong></div>
      <div>{fm(messages.toKnow)}</div>
      <ul>
        <li>{fm(messages.toKnow1)}</li>
        <li>{fm(messages.toKnow2)}</li>
        <li>{fm(messages.toKnow3, { a: (...chunks) => <a href='/settings/preferences'>{chunks}</a> })}</li>
        <li>{fm(messages.toKnow4, { a: (...chunks) => <a href='/premium'>{chunks}</a> })}</li>
      </ul>
      <a href='/news/4931-introducing-the-ride-with-gps-heatmap'>{fm(messages.learnMore)}</a>
    </div>
  )
}
